"use client";

import AnimatedLogo from "@/components/error/animated_logo";
import { Button } from "@/components/ui/button";
import * as m from "@/paraglide/messages";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-background overflow-hidden absolute w-screen left-0 top-0 z-40">
      <div className="w-58 h-58 mb-8">
        <AnimatedLogo />
      </div>

      <h1 className="text-xl font-medium text-gray-900 dark:text-white mb-2">
        {m.Oops()}
      </h1>

      <p className="text-gray-600 dark:text-gray-400 text-center mb-6 max-w-3xl">
        {error.name ? error.name + ": " : ""}
        {error.message ?? m.boundary_message()}{" "}
        {error.digest ? (
          <>
            <br />
            <br />
            {error.digest}
          </>
        ) : (
          <></>
        )}
      </p>

      <Button variant="outline" onClick={reset}>
        <svg
          className="w-4 h-4 me-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
        {m.try_again()}
      </Button>
    </main>
  );
}
